import store from '../store'
import TokenCookie from '../services/TokenCookie'

export default async function auth (to, from, next) {
  if (!store.getters['auth/isAuthenticated']) {
    return next({
      name: 'login'
    })
  } else if (!store.getters['user/isProfileLoaded']) {
    try {
      await store.dispatch('user/getProfile')
    } catch (e) {
      if (e.response.status === 401) {
        TokenCookie.remove()
        return next({
          name: 'login'
        })
      }
    }
    store.commit('setLang', store.state.user.profile.lang)
  }

  return false
}
